export default "__VITE_ASSET__D6gGzRe8__"